module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921031151_T.a7baf452.jpg";